import moment from "moment";
import { BKK_TIMEZONE } from "constants/Time";

export const tickFormatterToTime = (tick: number) => moment(tick).utc().utcOffset(BKK_TIMEZONE).format("HH:mm");
export const tickFormatterToDate = (tick: number) => moment(tick).utc().utcOffset(BKK_TIMEZONE).format("DD/MM");
export const tickFormatterToMonth = (tick: number) => moment(tick).utc().utcOffset(BKK_TIMEZONE).format("MMM YY");
